import Avatar from "./basic-7-avatar.jpg";
import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";

import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic7 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #7";
    this.id = "8";
    this.url = "/ai/carousels/basic-7";
    this.description =
      "Create a simple and sleek carousel without the need for your image";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Kari Rasmussen",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@kariras",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#1D2939",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#ffffff",
        },
        {
          label: "Secondary Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#6CE8A5",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Spline Sans",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "multiline",
            value: "18 PRINCIPLES FOR THE 'PERFECT' LINKEDIN POST",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "multiline",
            value: `Strong hook`,
            max_words: 2,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Thousands of posts are shared online every day.
Give people a reason to stop the scroll.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "multiline",
            value: `SPECIFIC NUMBERS`,
            max_words: 2,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Include specific numbers in your hook so your audience knows what to expect.            `,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "multiline",
            value: `SHOW CREDIBILITY`,
            max_words: 2,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `The messenger matters.

Who said something matters just as much as what they said.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "If you got this far and found this post valuable:",
            max_words: 10,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "FOLLOW ME",
            max_words: 2,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getBackgroundColorVariant(common_settings) {
    return this.getBackgroundColor(common_settings) + "20";
  }

  getBackgroundColorVariantSecond(common_settings) {
    return this.getBackgroundColor(common_settings) + "40";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Spline Sans";
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute inset-x-0 px-10 py-14">
          <img
            className="object-cover w-32 h-32 rounded-full"
            src={
              commonSettings.elements[1].value.image
                ? commonSettings.elements[1].value.image
                : LogoPlaceholder
            }
            alt=""
          />
          <div
            className="mt-5 text-2xl font-semibold"
            style={{
              color: this.getSecondaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="mt-4 text-4xl font-semibold tracking-tight uppercase"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
        <div className="absolute inset-x-0 bottom-0 px-10 pb-8">
          <div className="flex items-end justify-between gap-6">
            <div className="inline-flex items-center gap-3">
              <div>
                <p
                  className="text-lg font-bold"
                  style={{
                    color: this.getSecondaryColor(commonSettings),
                  }}
                >
                  {commonSettings.elements[0].value}
                </p>

                <p
                  className="text-sm font-normal"
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                  }}
                >
                  {commonSettings.elements[2].value}
                </p>
              </div>
            </div>
            <svg
              className="w-auto h-5"
              style={{
                color: this.getPrimaryColor(commonSettings),
              }}
              viewBox="0 0 97 20"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M20 10.2715C19.9397 12.8956 18.89 15.3646 16.7644 17.3557C15.7925 18.2662 14.6695 18.9393 13.4193 19.3929C12.0507 19.8904 10.5899 20.0826 9.1393 19.9559C7.68869 19.8292 6.2833 19.3867 5.02156 18.6595C4.92447 18.6036 4.846 18.6213 4.75437 18.6548C3.57485 19.0849 2.39532 19.5167 1.21407 19.9408C0.863685 20.0665 0.540869 19.9904 0.276656 19.7286C0.00871841 19.463 -0.0672676 19.1375 0.060369 18.7815C0.489467 17.5835 0.923034 16.3871 1.36107 15.1924C1.37514 15.1587 1.38069 15.1221 1.37723 15.0857C1.37376 15.0494 1.36139 15.0144 1.34121 14.984C0.912669 14.2471 0.582648 13.457 0.359595 12.6342C0.0714628 11.591 -0.0428892 10.5074 0.0211344 9.42699C0.151585 7.27478 0.89398 5.36025 2.24832 3.68341C3.33422 2.34179 4.68831 1.35223 6.29222 0.712482C7.66774 0.160784 9.14935 -0.075481 10.6281 0.021055C14.4555 0.256582 17.8163 2.67595 19.2632 6.24166C19.7514 7.44389 19.9898 8.69681 20 10.2715Z" />
              <path d="M55.2253 0.45459C52.1855 0.45459 50.5003 2.62897 50.5003 2.62897C50.5003 2.62897 48.815 0.45459 45.7753 0.45459C42.5854 0.45459 40.0002 3.01598 40.0002 6.17663C40.0002 10.516 45.1579 14.7212 46.5953 16.0498C48.2512 17.5791 50.5003 19.5454 50.5003 19.5454C50.5003 19.5454 52.7494 17.5791 54.4052 16.0498C55.8427 14.7212 61.0003 10.516 61.0003 6.17663C61.0003 3.01598 58.4152 0.45459 55.2253 0.45459Z" />
              <path d="M96.2734 18.4153C96.2734 18.8843 95.7403 19.1543 95.3622 18.8769L88.9757 14.1911C88.7742 14.0433 88.4999 14.0433 88.2984 14.1911L81.9119 18.8769C81.5338 19.1543 81.0007 18.8843 81.0007 18.4153V1.0271C81.0007 0.710912 81.2571 0.45459 81.5732 0.45459H95.7009C96.0171 0.45459 96.2734 0.710912 96.2734 1.0271V18.4153Z" />
            </svg>
          </div>
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute inset-x-0 px-10 py-14">
          <div className="flex items-center gap-4 pr-6">
            <p
              className="font-semibold text-8xl"
              style={{
                color: this.getSecondaryColor(commonSettings),
              }}
            >
              {index}
            </p>
            <div
              className="text-4xl font-semibold tracking-tight uppercase"
              style={{
                color: this.getPrimaryColor(commonSettings),
              }}
            >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
            </div>
          </div>
<div
            className="mt-4 text-lg font-normal"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute inset-x-0 px-10 py-14">
          <div
            className="text-5xl font-semibold uppercase"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getPrimaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            ></div>
          )}
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 && (
          <div className="absolute inset-x-0 bottom-0 px-10 pb-8">
            <div className="flex items-end justify-between gap-6">
              <div className="inline-flex items-center gap-3">
                <img
                  className="w-12 h-12 rounded-full shrink-0"
                  src={
                    commonSettings.elements[1].value.image
                      ? commonSettings.elements[1].value.image
                      : LogoPlaceholder
                  }
                  alt=""
                />
                <div>
                  <p
                    className="text-lg font-bold whitespace-nowrap"
                    style={{ color: this.getPrimaryColor(commonSettings) }}
                  >
                    {commonSettings.elements[0].value}
                  </p>
                  <p
                    className="text-sm font-normal"
                    style={{ color: this.getPrimaryColor(commonSettings) }}
                  >
                    {commonSettings.elements[2].value}
                  </p>
                </div>
              </div>
              <div
                className="inline-flex items-center justify-center w-12 h-12 rounded-full"
                style={{
                  backgroundColor: this.getSecondaryColor(commonSettings),
                  color: this.getBackgroundColor(commonSettings),
                }}
              >
                <svg
                  className="w-5 h-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Basic7;
